import { EntityKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class SollicitationsRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of sollicitations.
     *
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: count sollicitations.
     *
     */
    async count() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/sollicitations/private/count`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.SOLLICITATIONS }) };
        }
    }
    /**
     * Call API: get sollicitations by type.
     *
     */
    async getSollicitationsByType(sollicitationsType, pagination, status, filters) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement/api/tenants/${this.tenantId}/sollicitations/private/${sollicitationsType}/search`, {
                offset: pagination.from,
                limit: pagination.size,
                sollicitationsStatus: status,
                query: filters?.text,
            });
            const response = {
                type: res.data.type,
                awaitingActions: res.data.awaitingActions || [],
                completedActions: res.data.completedActions || [],
                total: {
                    awaiting: res.data.total.awaiting || '',
                    completed: res.data.total.completed || '',
                },
            };
            return { response };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.SOLLICITATIONS }) };
        }
    }
}
export { SollicitationsRestAdapter };
//# sourceMappingURL=sollicitations-rest.adapter.js.map